import React, { useState } from 'react';
import axios from 'axios';
import '../design/login.css';
import Footer from "../components/ui/footer";

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    const payload = { username, password };

    try {
      const response = await axios.post('https://api.deliquentauction.com/auth/login/', payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.status === 200) {
        const { access_token, refresh_token } = response.data;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        alert('Login successful!');
        window.location.href = '/dashboard';
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setErrorMessage('Invalid username or password');
      } else {
        setErrorMessage('An error occurred. Please try again later.');
      }
    }
  };

  return (
    <div className="page-wrapper">
      <div className="login-container">
        <a href="/">
          <img src="/logo.png" alt="Logo" />
        </a>
        <form onSubmit={handleLogin}>
          <div>
            <label>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit">Login</button>
        </form>

        {errorMessage && <p className="error">{errorMessage}</p>}

        <div>
          <p>
            Don't have an account?&nbsp;&nbsp;
            <a href="/signup">Sign Up</a>&nbsp;&nbsp;
            <a href="/forgot-password">Forgot Password?</a>
          </p>
        </div>
      </div>

      <div className="login-footer">
        <Footer />
      </div>
    </div>
  );
};

export default LoginPage;
